var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "facebook-login-button" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-facebook",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.onClick.apply(null, arguments)
          }
        }
      },
      [
        _c("img", {
          attrs: { src: "/img/icons/facebook-logo.svg", alt: "Facebook" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm._f("capitalize")(_vm.lang.labels.facebook)))
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }